import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/utils/cn'

interface SpectreThinkingBadgeProps {
  visible: boolean
  label?: string
  className?: string
}

export function SpectreThinkingBadge({ visible, label, className }: SpectreThinkingBadgeProps) {
  const { t } = useTranslation()
  if (!visible) return null
  const resolvedLabel = label ?? t('investigations.graph.aiInsights.spectreThinking')
  return (
    <span
      data-slot="spectre-thinking-badge"
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-2 py-0.5',
        'text-3xs font-medium uppercase tracking-wide text-primary',
        'animate-pulse',
        className
      )}
    >
      <Sparkles className="size-3" />
      {resolvedLabel}
    </span>
  )
}
